<template>
    <div class="basic-actions">
        <div class="scopes-table">
            <div class="scopes-table-header">
                <div
                    v-for="column in columns"
                    class="scopes-table-header-item"
                    :class="{ [column.headerClassNames]: true }"
                    :key="column.id"
                    :style="{
                        flex: column.flex,
                        width: column.width ? column.width + 'px' : 'auto',
                        'max-width': column.maxWidth ? column.maxWidth + 'px' : 'auto',
                    }"
                >
                    <template>{{ column.title }}</template>
                </div>
            </div>
            <div class="scopes-table-body">
                <div class="row" v-for="row in rows()" :key="row.id">
                    <div
                        class="cell"
                        v-for="column in columns"
                        :key="column.id"
                        :style="{
                            flex: column.flex,
                            width: column.width ? column.width + 'px' : 'auto',
                            'max-width': column.maxWidth ? column.maxWidth + 'px' : 'auto',
                        }"
                        :class="{ [column.rowClassNames]: true }"
                        @click="toggleActive(row.id, column.slot)"
                    >
                        <template v-if="column.slot === 'web'">
                            <SupsisButton>
                                <i
                                    class="material-icons spin-effect"
                                    v-if="loading && loading.item == row.id && loading.platform == 'web'"
                                    >sync</i
                                >
                                <i class="material-icons text-success" v-else-if="isActive(row.id, 'web')">done</i>
                                <div
                                    class="disabled-item"
                                    @mouseenter="hoverEffect($event, true)"
                                    @mouseleave="hoverEffect($event, false)"
                                    v-else
                                >
                                    <i class="material-icons">done</i>
                                    <i class="material-icons">circle</i>
                                </div>
                            </SupsisButton>
                        </template>
                        <template v-else-if="column.slot === 'mobile'">
                            <SupsisButton>
                                <i
                                    class="material-icons spin-effect"
                                    v-if="loading && loading.item == row.id && loading.platform == 'mobile'"
                                    >sync</i
                                >
                                <i class="material-icons text-success" v-else-if="isActive(row.id, 'mobile')">done</i>
                                <div
                                    class="disabled-item"
                                    @mouseenter="hoverEffect($event, true)"
                                    @mouseleave="hoverEffect($event, false)"
                                    v-else
                                >
                                    <i class="material-icons">done</i>
                                    <i class="material-icons">circle</i>
                                </div>
                            </SupsisButton>
                        </template>
                        <template v-else-if="column.slot === 'email'">
                            <SupsisButton>
                                <i
                                    class="material-icons spin-effect"
                                    v-if="loading && loading.item == row.id && loading.platform == 'email'"
                                    >sync</i
                                >
                                <i class="material-icons text-success" v-else-if="isActive(row.id, 'email')">done</i>
                                <div
                                    class="disabled-item"
                                    @mouseenter="hoverEffect($event, true)"
                                    @mouseleave="hoverEffect($event, false)"
                                    v-else
                                >
                                    <i class="material-icons">done</i>
                                    <i class="material-icons">circle</i>
                                </div>
                            </SupsisButton>
                        </template>
                        <template v-else>
                            <div class="first-cell">
<!--                                <i class="material-icons" v-if="row.id === 'chat-assign'">3p</i>-->
<!--                                <i class="material-icons" v-else-if="row.id === 'ticket-assign'"-->
<!--                                    >assignment_turned_in</i-->
<!--                                >-->
<!--                                <i class="material-icons" v-else-if="row.id === 'task-assign'">add_task</i>-->
<!--                                <i class="material-icons" v-else-if="row.id === 'chat-close-own'">mark_chat_read</i>-->
                                <i class="material-icons" v-if="row.icon">{{row.icon}}</i>
                                {{ row[column.id] }}
                            </div>
                        </template>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Vue from "vue";
import SupsisButton from "../../components/SupsisButton.vue";
import { ACTIVITY_API } from "../../../../../api/activity";

export default Vue.extend({
    name: "BasicActions",
    components: { SupsisButton },
    props: {
        settings: {
            type: Array,
            required: true,
        },
        title: {
            type: String,
            default: "Basic Actions",
        },
        allowedScopes: {
            type: Array,
            default: () => ["chat-assign", "ticket-assign", "task-assign", "chat-close-own"],
        },
        loading: {},
    },
    data() {
        return {
            scopeId: false,
            columns: [
                {
                    id: "label",
                    title: this.title,
                    flex: 5,
                    rowClassNames: "",
                    headerClassNames: "",
                },
                {
                    id: "web",
                    title: "WEB",
                    flex: 1,
                    slot: "web",
                    rowClassNames: "checkbox-cell",
                    headerClassNames: "center",
                },
                {
                    id: "mobile",
                    title: "MOBILE",
                    flex: 1,
                    rowClassNames: "checkbox-cell",
                    slot: "mobile",
                    headerClassNames: "center",
                },
                {
                    id: "email",
                    title: "EMAIL",
                    flex: 1,
                    rowClassNames: "checkbox-cell",
                    slot: "email",
                    headerClassNames: "center",
                },
            ],
        };
    },
    methods: {
        rows() {
            return [
                {
                    id: "chat-assign",
                    label: this.$t('notification.chatAssignedMe'),
                    web: this.isActive("chat-assign", "web"),
                    email: this.isActive("chat-assign", "email"),
                    mobile: this.isActive("chat-assign", "mobile"),
                    icon: "3p",
                },
                {
                    id: "ticket-assign",
                    label: this.$t('notification.ticketAssignedMe'),
                    web: this.isActive("ticket-assign", "web"),
                    email: this.isActive("ticket-assign", "email"),
                    mobile: this.isActive("ticket-assign", "mobile"),
                    icon: "assignment_turned_in",
                },
                {
                    id: "task-assign",
                    label: this.$t('notification.taskAssignedMe'),
                    web: this.isActive("task-assign", "web"),
                    email: this.isActive("task-assign", "email"),
                    mobile: this.isActive("task-assign", "mobile"),
                    icon: "add_task",
                },
                {
                    id: "chat-close-own",
                    label: this.$t('notification.myChatClosed'),
                    web: this.isActive("chat-close-own", "web"),
                    email: this.isActive("chat-close-own", "email"),
                    mobile: this.isActive("chat-close-own", "mobile"),
                    icon: "mark_chat_read",
                },
                {
                    id: "tag-actions-to-visitor",
                    label: this.$t('notification.tagActionsToVisitor'),
                    web: this.isActive("tag-actions-to-visitor", "web"),
                    email: this.isActive("tag-actions-to-visitor", "email"),
                    mobile: this.isActive("tag-actions-to-visitor", "mobile"),
                    icon:"bookmark",
                },
                {
                    id: "create-ticket",
                    label: this.$t('notification.ticketCreated'),
                    web: this.isActive("create-ticket", "web"),
                    email: this.isActive("create-ticket", "email"),
                    mobile: this.isActive("create-ticket", "mobile"),
                    icon:"confirmation_number",
                },
                {
                    id: "note-actions-to-visitor",
                    label: this.$t('notification.notesActions'),
                    web: this.isActive("note-actions-to-visitor", "web"),
                    email: this.isActive("note-actions-to-visitor", "email"),
                    mobile: this.isActive("note-actions-to-visitor", "mobile"),
                    icon:"sticky_note_2",
                },
                {
                    id: "visitor-profile-updates",
                    label: this.$t('notification.visitorProfileUpdated'),
                    web: this.isActive("visitor-profile-updates", "web"),
                    email: this.isActive("visitor-profile-updates", "email"),
                    mobile: this.isActive("visitor-profile-updates", "mobile"),
                    icon:"account_box",
                },

                {
                    id: "chat-start",
                    label: this.$t('notification.chatStartedByAnyPlatform'),
                    web: this.isActive("chat-start", "web"),
                    email: this.isActive("chat-start", "email"),
                    mobile: this.isActive("chat-start", "mobile"),
                    icon:"chat",
                },
                {
                    id: "user-crud",
                    label: this.$t('notification.userActions'),
                    web: this.isActive("user-crud", "web"),
                    email: this.isActive("user-crud", "email"),
                    mobile: this.isActive("user-crud", "mobile"),
                    icon:"person_add",
                },
                {
                    id: "department-crud",
                    label: this.$t('notification.departmentActions'),
                    web: this.isActive("department-crud", "web"),
                    email: this.isActive("department-crud", "email"),
                    mobile: this.isActive("department-crud", "mobile"),
                    icon:"domain_add",
                },
                {
                    id: "settings-crud",
                    label: this.$t('notification.settingsActions'),
                    web: this.isActive("settings-crud", "web"),
                    email: this.isActive("settings-crud", "email"),
                    mobile: this.isActive("settings-crud", "mobile"),
                    icon:"settings",
                },
                {
                    id: "integration-channel-crud",
                    label: this.$t('notification.integrationsActions'),
                    web: this.isActive("integration-channel-crud", "web"),
                    email: this.isActive("integration-channel-crud", "email"),
                    mobile: this.isActive("integration-channel-crud", "mobile"),
                    icon:"integration_instructions",
                },
                {
                    id: "login-form-crud",
                    label: this.$t('notification.loginFormActions'),
                    web: this.isActive("login-form-crud", "web"),
                    email: this.isActive("login-form-crud", "email"),
                    mobile: this.isActive("login-form-crud", "mobile"),
                    icon:"assignment",
                },
                {
                    id: "banned-word-crud",
                    label: this.$t('notification.bannedWordActions'),
                    web: this.isActive("banned-word-crud", "web"),
                    email: this.isActive("banned-word-crud", "email"),
                    mobile: this.isActive("banned-word-crud", "mobile"),
                    icon:"block",
                },
                {
                    id: "email-account-crud",
                    label: this.$t('notification.emailActions'),
                    web: this.isActive("email-account-crud", "web"),
                    email: this.isActive("email-account-crud", "email"),
                    mobile: this.isActive("email-account-crud", "mobile"),
                    icon:"contact_mail",
                },
                {
                    id: "prepared-content-crud",
                    label: this.$t('notification.preparedContentActions'),
                    web: this.isActive("prepared-content-crud", "web"),
                    email: this.isActive("prepared-content-crud", "email"),
                    mobile: this.isActive("prepared-content-crud", "mobile"),
                    icon:"content_copy",
                },
                {
                    id: "role-crud",
                    label: this.$t('notification.roleActions'),
                    web: this.isActive("role-crud", "web"),
                    email: this.isActive("role-crud", "email"),
                    mobile: this.isActive("role-crud", "mobile"),
                    icon:"admin_panel_settings",
                },
                {
                    id: "tag-crud",
                    label: this.$t('notification.tagActions'),
                    web: this.isActive("tag-crud", "web"),
                    email: this.isActive("tag-crud", "email"),
                    mobile: this.isActive("tag-crud", "mobile"),
                    icon:"bookmark",
                },
                {
                    id: "welcome-message-crud",
                    label: this.$t('notification.welcomeMessageActions'),
                    web: this.isActive("welcome-message-crud", "web"),
                    email: this.isActive("welcome-message-crud", "email"),
                    mobile: this.isActive("welcome-message-crud", "mobile"),
                    icon:"message",
                },
                {
                    id: "webhook-crud",
                    label: this.$t('notification.webhookActions'),
                    web: this.isActive("webhook-crud", "web"),
                    email: this.isActive("webhook-crud", "email"),
                    mobile: this.isActive("webhook-crud", "mobile"),
                    icon:"webhook",
                },
                {
                    id: "billing-events",
                    label: this.$t('notification.billingEvents'),
                    web: this.isActive("billing-events", "web"),
                    email: this.isActive("billing-events", "email"),
                    mobile: this.isActive("billing-events", "mobile"),
                    icon:"receipt_long",
                },
                {
                    id: "task-workflow-crud",
                    label: this.$t('notification.taskWorkflowCrud'),
                    web: this.isActive("task-workflow-crud", "web"),
                    email: this.isActive("task-workflow-crud", "email"),
                    mobile: this.isActive("task-workflow-crud", "mobile"),
                    icon:"task_alt",
                },
                {
                    id: "task-crud",
                    label: this.$t('notification.taskCrud'),
                    web: this.isActive("task-crud", "web"),
                    email: this.isActive("task-crud", "email"),
                    mobile: this.isActive("task-crud", "mobile"),
                    icon:"task",
                },
                {
                    id: "system-status",
                    label: this.$t('notification.systemStatus'),
                    web: this.isActive("system-status", "web"),
                    email: this.isActive("system-status", "email"),
                    mobile: this.isActive("system-status", "mobile"),
                    icon:"support_agent",
                },
                {
                    id: "chatbot-story-crud",
                    label: this.$t('notification.chatbotStoryCrud'),
                    web: this.isActive("chatbot-story-crud", "web"),
                    email: this.isActive("chatbot-story-crud", "email"),
                    mobile: this.isActive("chatbot-story-crud", "mobile"),
                    icon:"smart_toy",
                },
                {
                    id: "chatbot-forward-chat",
                    label: this.$t('notification.chatbotForwardAgent'),
                    web: this.isActive("chatbot-forward-chat", "web"),
                    email: this.isActive("chatbot-forward-chat", "email"),
                    mobile: this.isActive("chatbot-forward-chat", "mobile"),
                    icon:"forward_to_inbox",
                },
                {
                    id: "chatbot-user-segment-crud",
                    label: this.$t('notification.userSegmentCrud'),
                    web: this.isActive("chatbot-user-segment-crud", "web"),
                    email: this.isActive("chatbot-user-segment-crud", "email"),
                    mobile: this.isActive("chatbot-user-segment-crud", "mobile"),
                    icon:"group_add",
                },
                {
                    id: "chatbot-credit-low",
                    label: this.$t('notification.chatbotCreditLow'),
                    web: this.isActive("chatbot-credit-low", "web"),
                    email: this.isActive("chatbot-credit-low", "email"),
                    mobile: this.isActive("chatbot-credit-low", "mobile"),
                    icon:"money_off",
                },
                {
                    id: "whatsapp-credit-low",
                    label: this.$t('notification.wpCreditLow'),
                    web: this.isActive("whatsapp-credit-low", "web"),
                    email: this.isActive("whatsapp-credit-low", "email"),
                    mobile: this.isActive("whatsapp-credit-low", "mobile"),
                    icon:"money_off",
                },
                {
                    id: "whatsapp-customer-group-crud",
                    label: this.$t('notification.wpCustomerGroupCrud'),
                    web: this.isActive("whatsapp-customer-group-crud", "web"),
                    email: this.isActive("whatsapp-customer-group-crud", "email"),
                    mobile: this.isActive("whatsapp-customer-group-crud", "mobile"),
                    icon:"group_add",
                },
                {
                    id: "whatsapp-broadcast-message-crud",
                    label: this.$t('notification.wpBroadcastMessageStatus'),
                    web: this.isActive("whatsapp-broadcast-message-crud", "web"),
                    email: this.isActive("whatsapp-broadcast-message-crud", "email"),
                    mobile: this.isActive("whatsapp-broadcast-message-crud", "mobile"),
                    icon:"campaign",
                },
                {
                    id: "whatsapp-template-message-crud",
                    label: this.$t('notification.wpTemplateMesssageCrud'),
                    web: this.isActive("whatsapp-template-message-crud", "web"),
                    email: this.isActive("whatsapp-template-message-crud", "email"),
                    mobile: this.isActive("whatsapp-template-message-crud", "mobile"),
                    icon:"add_comment",
                },
            ].filter((row) => this.allowedScopes.includes(row.id));
        },
        hoverEffect(e, hover) {
            e.target.classList[hover ? "add" : "remove"]("active");
        },
        getScopeSettings() {
            return this.settings.filter((setting) => this.allowedScopes.includes(setting.scope));
        },
        isActive(scope, platform) {
            const setting = this.getScopeSettings().find((setting) => setting.scope === scope);
            console.log("isActive", { scope, platform, setting, getScopeSettings: this.getScopeSettings() });
            if (!setting) {
                return false;
            } else {
                return setting[platform];
            }
        },
        toggleActive(item, platform) {
            const status = this.isActive(item, platform);
            this.loading = {
                platform,
                item,
            };
            setTimeout(() => {
                ACTIVITY_API.NOTIFICATION.updateSingleSetting(platform, item, !status).then(() => {
                    this.$emit("update", item, platform, !status);
                    this.loading = null;
                });
            }, 100);
        },
    },
});
</script>

<style scoped lang="scss">
.scopes-table {
    width: 100%;
    .spin-effect {
        color: rgb(62, 62, 213);
        animation: spinEffect 1s infinite;
    }

    @keyframes spinEffect {
        0% {
            transform: rotate(365deg);
        }
        100% {
            transform: rotate(0deg);
        }
    }

    .scopes-table-header {
        display: flex;
        align-items: center;
        width: 100%;
        padding: 10px;

        .scopes-table-header-item {
            flex: 1;
            text-transform: none;
            font-size: 14px;
            font-weight: 700;
            color: var(--color-text-strong-default);

            &.center {
                justify-content: center;
                display: flex;
            }
        }
    }

    .scopes-table-body {
        display: flex;
        flex-direction: column;
        //gap: 10px;
        width: 100%;
        align-items: center;
        overflow-y: auto;
        height: 100%;
        max-height: calc(100vh - 100px);

        .row:nth-child(odd) {
            background: var(--color-bg-neutral-default);
        }

        .row {
            display: flex;
            align-items: center;
            gap: 20px 10px;
            width: 100%;

            background: var(--color-bg-default);
            cursor: pointer;

            &:hover {
                opacity: 0.8;
            }

            .cell {
                flex: 1;
                font-size: 14px;
                font-weight: 400;
                color: var(--color-text-default);
                line-height: 19px;
                overflow: hidden !important;
                text-overflow: ellipsis;
                white-space: nowrap;
                padding: 10px;
                min-height: 50px;
                display: flex;
                align-items: center;

                .disabled-item {
                    :first-child {
                        display: none;
                    }
                    &.active {
                        :first-child {
                            display: block;
                        }
                        :last-child {
                            display: none;
                        }
                    }
                }
                .first-cell {
                    display: flex;
                    align-items: center;
                    gap: 5px;

                    .material-icons {
                        font-size: 18px;
                        color: var(--color-icon-default);
                    }
                }
            }

            .checkbox-cell {
                padding: 0 !important;

                .material-icons {
                    font-size: 20px;
                }

                .supsis-button {
                    min-height: 50px !important;
                    width: 100% !important;
                    max-width: unset !important;
                    border: none !important;
                    background: none !important;

                    &:hover {
                        background: var(--color-bg-primary-subdued-hover) !important;
                    }
                }

                &:hover {
                    .supsis-button {
                        background: var(--color-bg-primary-subdued-hover) !important;
                    }
                }
            }
        }
    }
}
</style>
